import gsap from 'gsap';

$(function() {
    const customCursor = document.querySelector('.js-custom-cursor');
    const sectionWithCursor = document.querySelector('.js-section-with-cursor');
    const customDragCursor = document.querySelector('.js-custom-drag-cursor');
    const sectionWithDragCursor = document.querySelector('.clients__list');

    function isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    function updateCursorPosition(cursor) {
        window.addEventListener('mousemove', (e) => {
            const { target } = e;
            const isTargetSection = target?.closest('.js-section-with-cursor');
            gsap.to(cursor, {
                x: e.clientX - cursor.offsetWidth / 2,
                y: e.clientY - cursor.offsetHeight / 2,
                duration: 0.7,
                ease: 'power5',
                position: 'fixed',
                opacity: isTargetSection ? 1 : 0,
                transform: `scale(${isTargetSection ? 1 : 0})`
            });
        });

        window.addEventListener('mouseleave', (e) => {
            gsap.to(cursor, {
                x: e.clientX - cursor.offsetWidth / 2,
                y: e.clientY - cursor.offsetHeight / 2,
                duration: 0.7,
                ease: 'power5',
                position: 'fixed',
                opacity: 0
            });
        });
    }

    function updateCursorPositionForDrag(cursor, section, initX, initY) {
        section.addEventListener('mousemove', function(e) {
            let x = e.clientX;
            let y = e.clientY;
            const rect = section.getBoundingClientRect();
            let relativeX = Math.max(0, Math.min(rect.width, x - rect.left));
            let relativeY = Math.max(0, Math.min(rect.height, y - rect.top));

            gsap.to(cursor, {
                x: relativeX - cursor.offsetWidth / 2,
                y: relativeY - cursor.offsetHeight / 2,
                duration: 0.7,
                ease: 'power4'
            });
        });

        section.addEventListener('mouseleave', function(e) {
            gsap.to(cursor, {
                x: initX,
                y: initY,
                duration: 0.7,
                ease: 'power4'
            });
        });
    }

    function setupCursor() {
        const isDeviceMobile = isMobile();

        if (customCursor && sectionWithCursor) {
            const centerX = (window.innerWidth / 2) - (customCursor.offsetWidth / 2);
            const centerY = (sectionWithCursor.clientHeight / 2) - (customCursor.offsetHeight / 2);

            if (!isDeviceMobile) {
                customCursor.style.position = 'fixed';
                customCursor.style.transform = `scale(0)`;
                customCursor.style.opacity = 0;
                updateCursorPosition(customCursor);
            } else {
                customCursor.style.position = 'absolute';
                customCursor.style.transform = `translate(${centerX}px, ${centerY}px`;
                customCursor.style.opacity = 1;
            }
        }

        if (customDragCursor && sectionWithDragCursor) {
            const initX = (window.innerWidth / 2);
            const initY = 0;
            customDragCursor.style.transform = `translate(${initX}px, ${initY}px)`;
            customDragCursor.style.opacity = 1;

            if (!isDeviceMobile) {
                updateCursorPositionForDrag(customDragCursor, sectionWithDragCursor, initX, initY);
                customDragCursor.style.display = 'block';
            } else {
                customDragCursor.style.display = 'none';
            }
        }
    }

    setupCursor();

    window.addEventListener('resize', function() {
        setupCursor();
    });
});